module.exports = __webpack_public_path__ + "static/media/confirmed.7509a4f5.svg";